import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {TimelineLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BuffaloPickBonus} from "./BuffaloPickBonus";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
/**
 * Created by jonas on 2020-03-23.
 *
 * This wrapper is needed because GameModeTransitionView extends BseView. That in turn is not compatible with
 * StageLayer, because both of them has a different signature onResize function.
 *
 * And StageLayer is the way of the future, bot BaseView.
 */

export class BuffaloTransitionViewWrapper extends BaseView implements GameModeTransitionView {

    private _pickBonusView:BuffaloPickBonus;
    private _isPick:boolean = false;
    private _data:WinterHoardParsedGameData;
    private _debug:boolean = false;

    constructor(pick:boolean = false, debug:boolean = false) {
        super();

        this._isPick = pick;//pick;
        this._debug = debug;
    }

    protected initAnimations():void {
        this._pickBonusView = new BuffaloPickBonus();
    }

    prepare(data:WinterHoardParsedGameData):void {
        this._data = data;
        WinterHoardGameModuleConfig.freeSpinIntroView.prepare(data);
    }

    getStartAnimation(prepareToEnterModeCallback:() => void, completeCallback:() => void):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if (this._isPick){
            tl.add(()=>{
                prepareToEnterModeCallback();
                completeCallback();
            })
        } else {
            tl.add(WinterHoardGameModuleConfig.freeSpinIntroView.showSuperBonus(prepareToEnterModeCallback, completeCallback));
        }

        return tl;
    }

    getEndAnimation():TimelineLite {
        return WinterHoardGameModuleConfig.freeSpinIntroView.getEndAnimation(this._data);
    }

}